import React from "react";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import { CourseStatusChip, Divider, Typography, makeStyles } from "../../../..";
import { Link } from "react-router-dom";
import { Grid } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    flex: {
      display: "flex",
      "justify-content": "space-between",
      "margin-bottom": "15px" // "align-items": "top"

    },
    box: {
      "border-radius": "4px",
      border: "1px solid #7d7d7d",
      minHeight: "260px",
      maxHeight: "260px"
    }
  };
});

var AcademyCard = function AcademyCard(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Link, {
    to: "/academy/courses/" + props._id,
    style: {
      textDecoration: "none"
    }
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.box
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, props.name), props.variant !== "franchise" && /*#__PURE__*/React.createElement(CourseStatusChip, {
    status: props.status
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, props.description.length > 200 ? "".concat(props.description.substr(0, 138), " ...") : props.description), props.variant !== "franchise" && /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: "8px"
    }
  })), /*#__PURE__*/React.createElement(CardActions, null, props.variant !== "franchise" && /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Languages")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      display: "flex",
      flexFlow: "row wrap"
    }
  }, props.languages.map(function (language) {
    return /*#__PURE__*/React.createElement(CourseStatusChip, {
      status: language.status,
      label: language.language,
      style: {
        margin: "4px"
      }
    });
  }))))));
};

export { AcademyCard };